// React
import React from 'react'
// GraphQL
import { graphql } from 'react-apollo'
// GraphQL Mutation
import { saveBirthData } from '../../graphql/mutations/user'
// Components
import EntryForm from './EntryForm'
import LifePurposeApp from '../Footer/LifePurposeApp'
import Logo from '../Display/Logo'
import Social from '../Display/Social'
import Tab from './Tab'

class Home extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			birthDate: { day: 0, month: 0, year: 0 },
			birthPlace: { address: 'New York, NY, USA', lat: 40.70, lng: -73.98 },
			birthTime: { hour: 12, minute: 0, pm: true, timezone: 'America/New_York', utcOffset: -4 },
			birthSigns: {
				sun: { degree: 0, minute: 0, name: '' },
				moon: { degree: 0, minute: 0, name: '' }
			}
		}
	}

	componentWillMount() {
		if (this.props.user) {
			const { birthDate, birthPlace, birthTime, birthSigns } = this.props.user
			if (birthDate && birthPlace && birthTime && birthSigns) {
				this.setState({
					birthDate: { day: birthDate.day, month: birthDate.month, year: birthDate.year },
					birthPlace: { address: birthPlace.address, lat: birthPlace.lat, lng: birthPlace.lng },
					birthTime: { hour: birthTime.hour, minute: birthTime.minute, pm: birthTime.pm, timezone: birthTime.timezone, utcOffset: birthTime.utcOffset },
					birthSigns: {
						sun: { degree: birthSigns.sun.degree, minute: birthSigns.sun.minute, name: birthSigns.sun.name },
						moon: { degree: birthSigns.moon.degree, minute: birthSigns.moon.minute, name: birthSigns.moon.name }
					}
				})
			}
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0)
	}


	// GRAPHQL
	updateBirthData = (birthDate, birthPlace, birthTime, birthSigns) => {
		this.setState({ birthDate, birthPlace, birthTime, birthSigns })
		if (this.props.user) {
			this.props.saveBirthData({ variables: { userId: this.props.user.id, birthDate, birthPlace, birthTime, birthSigns } })
				.then(() => {
					// Load page
					this.props.redux.nav.addPage(birthSigns.moon.name, { name: birthSigns.moon.name, degree: birthSigns.moon.degree, minute: birthSigns.moon.minute })
				})
				.catch((err) => console.log(err))
		}
		else {
			// Load page
			this.props.redux.nav.addPage(birthSigns.moon.name, { name: birthSigns.moon.name, degree: birthSigns.moon.degree, minute: birthSigns.moon.minute })
		}
	}


	render() {
		const {
			birthDate,
			birthPlace,
			birthTime,
			birthSigns
		} = this.state
		return (
			<div>
				<Logo {...this.props} />
				<Tab {...this.props} />
				<div className='capps-container'>

					{/* ENTRY */}
					<center><div className='capps-text'>Enter your date, time, and place of birth:</div></center>
					<div className='capps-height-10' />
					<EntryForm
						birthDate={birthDate}
						birthTime={birthTime}
						birthPlace={birthPlace}
						birthSigns={birthSigns}
						updateBirthData={(birthDate, birthPlace, birthTime, birthSigns) => this.updateBirthData(birthDate, birthPlace, birthTime, birthSigns)}
						{...this.props}
					/>

					{/* SIGN UP */}
					{!this.props.user &&
						<div>
							<div className='capps-height-10' />
							<div onTouchTap={() => this.props.redux.nav.setPage('login')} className='capps-footer'>Sign up for free to save your information and access advanced features.</div>
							<div className='capps-height-20' />
							<div className='capps-footer' onTouchTap={() => {
								window.localStorage.setItem('MoonSignApp:welcome', true)
								this.props.redux.nav.setPage('')
							}}>
								<span className='capps-link'>About the Moon Sign App</span>
							</div>
						</div>
					}

					{this.props.user && <LifePurposeApp {...this.props} />}

				</div>
				<Social />
			</div>
		)
	}
}

export default graphql(saveBirthData, { name: 'saveBirthData' })(Home)



// WEBPACK FOOTER //
// ./src/Components/Home/Home.js